import { render, staticRenderFns } from "./ProductQuickEditGroup.vue?vue&type=template&id=d4b88908&scoped=true"
import script from "./ProductQuickEditGroup.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b88908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b88908')) {
      api.createRecord('d4b88908', component.options)
    } else {
      api.reload('d4b88908', component.options)
    }
    module.hot.accept("./ProductQuickEditGroup.vue?vue&type=template&id=d4b88908&scoped=true", function () {
      api.rerender('d4b88908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditGroup.vue"
export default component.exports